const localization = [
  {
  	lang: "tr",
    keys:[
        { key: "phone_not_found", value: "Telefon numarasını ekleyiniz." },
        { key: "already_exist_email", value: "Bu mail hesabı zaten mevcut." },
        { key: "signin_customer_not_found ", value: "Kayıtlı kullanıcı bulunamadı." },
        { key: "phone_not_valid", value: "Telefon numarası geçerli değil." },
        { key: "sms_code_verificated", value: "Sms kod doğrulandı." },
        { key: "sms_code_not_verificated", value: "Sms kod doğrulanamadı." },
        { key: "customer_not_found", value: "Kullanıcı bulunamadı." },
        { key: "returncode_empty_message", value: "Henüz iade kodu oluşmadı, lütfen daha sonra tekrar kontrol ediniz." },
        { key: "exist-disabled-customer-email-header", value: "Aktif olmayan bir hesabınız bulunmaktadır!" },
        { key: "exist-disabled-customer-email", value: "Hesabınız aktif değildir. Aktif etmek için hesap aktivasyonu sağlamanız gerekmektedir. {0}" },
        { key: "exist-disabled-customer-email-link", value: "Aktivasyon mailini adresinize göndermek için tıklayınız." },
        { key: "exist-disabled-customer-sent-activation", value: "Aktivasyon linki {0} mail adresinize gönderildi." },
        { key: "exist-disabled-customer-sending-email", value: "Aktivasyon linki mail adresinize gönderiliyor. Lütfen bekleyiniz." },
        { key: "exist-disabled-customer-sent-activation-fail", value: "Aktivasyon linki mail adresinize gönderilemedi. Lütfen daha sonra tekrar deneyiniz." },
        { key: "customer_not_saved", value: "Müşteri kayıt işleminiz başarısız olmuştur, lütfen tekrar deneyin." },
    ]
  },
  {
  	lang: "en",
    keys:[
        { key: "phone_not_found", value: "Enter your phone number." },
        { key: "already_exist_email", value: "This account already exist." },
        { key: "signin_customer_not_found", value: "Sign in customer not found."},
        { key: "order_item_not_found", value: "order_item_not_found." },
        { key: "phone_not_valid", value: "phone not valid." },
        { key: "sms_code_verificated", value: "sms code verificated ." },
        { key: "sms_code_not_verificated", value: "sms code not verificated." },
        { key: "customer_not_found", value: "customer not found." },
        { key: "returncode_empty_message", value: "No refund code has been generated yet, please check later." },
        { key: "exist-disabled-customer-email-header", value: "An inactive account was found!" },
        { key: "exist-disabled-customer-email", value: "Your account is not active. You need to activate your account to activate it. {0}" },
        { key: "exist-disabled-customer-email-link", value: "Click to send the activation link to your email address." },
        { key: "exist-disabled-customer-sent-activation", value: "exist-disabled-customer-sent-activation" },
        { key: "exist-disabled-customer-sending-email", value: "exist-disabled-customer-sending-email" },
        { key: "exist-disabled-customer-sent-activation-fail", value: "exist-disabled-customer-sent-activation-fail" },
        { key: "customer_not_saved", value: "Your customer registration has failed, please try again." },
    ]
  }
];

function getLocalizedText(key){
  return localization.find(z => z.lang == Shopify.locale)?.keys.find(z=> z.key == key)?.value ?? key;
}


/*
 order_line_not_found = "order_line_not_found";
 order_not_found = "order_not_found";
 already_exist_refund_order = "already_exist_refund_order";
 already_exist_refund_order_item = "already_exist_refund_order_item";
 order_item_not_found = "order_item_not_found";
 order_line_not_found = "order_line_not_found";
 order_not_found = "order_not_found";
 customer_not_found = "customer_not_found";
 already_exist_refund_order = "already_exist_refund_order";
 already_exist_refund_order_item = "already_exist_refund_order_item";
 
 */
